/**
 * LE FOCUS QUI QUITTE LE MENU LE FERME-T-IL ? Seulement quand il part vers un
 * AUTRE element (Tab, Maj+Tab) : `relatedTarget` le nomme, hors du menu.
 *
 * PAS QUAND IL PART VERS RIEN (`relatedTarget` nul). C'est le cas de Safari :
 * il ne donne pas le focus a un bouton qu'on clique. Le `mousedown` sur une
 * personne retirait le focus de l'entree active vers le vide, le menu se
 * refermait AVANT le `click`, et le choix se perdait : chez TAC (Safari), on
 * ne pouvait pas changer d'agenda ; sous Chrome, le bouton clique recoit le
 * focus et rien ne se voyait. Le clic dehors reste ferme par `pointerdown`.
 */
export function fermeAuBlur(menu: { contains(noeud: Node | null): boolean }, cible: EventTarget | null): boolean {
  return cible !== null && !menu.contains(cible as Node);
}
